import React from 'react';

import { useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import ResourceTypeStore from '../../../stores/ResourceTypeStore';

const ResourceTypeEditPage = ({ users }) => {
    const navigate = useNavigate();

    const store = ResourceTypeStore((state) => state);

    //useParams returns strings, so we convert it to a number here
    const resourceTypeId = Number(useParams().resourceTypeId);

    useEffect(() => {
        store.load(resourceTypeId);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == store.resourceType) {
        return <div>Loading ...</div>;
    }

    const getFormInputComponent = function (resourceType, attributeName) {
        switch (attributeName) {
            case 'id':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>ID</FormLabel>
                        <FormControl
                            type="text"
                            readOnly
                            disabled
                            value={resourceType.id}
                        />
                    </FormGroup>
                );

            case 'name':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Label<span className="text-danger">*</span>
                        </FormLabel>

                        <FormControl
                            type="text"
                            value={resourceType.name}
                            onChange={(e) => {
                                store.updateAttribute('name', e.target.value);
                            }}
                        />
                    </FormGroup>
                );

            default:
                return null;
        }
    };

    var formInputElements = [];

    formInputElements.push(getFormInputComponent(store.resourceType, 'id'));
    formInputElements.push(getFormInputComponent(store.resourceType, 'name'));

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/resourceType/');
                        }}
                    >
                        Back to list
                    </Button>
                    <div>ResourceType Edit Page</div>
                    <br />
                    <form>
                        {formInputElements}

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                navigate('/resourceType');
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.update(
                                    store.resourceType,
                                    () => {
                                        alert('Your edits were saved');
                                        navigate('/resourceType');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Save
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.delete(
                                    store.resourceType.id,
                                    () => {
                                        alert('The resourceType was deleted');
                                        navigate('/resourceType');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Delete
                        </Button>
                    </form>
                </Col>
            </Row>
        </Container>
    );
};

export default ResourceTypeEditPage;
